import { Radio as AntdRadio, Checkbox, Col, Row } from 'antd'
import Button from 'components/Button'
import DragDiv from 'components/DragDiv/index.js'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Radio from 'components/Form/RadioWithBorder'
import RichEditor from 'components/RichEditor/RoundRichText.js'
import {
  FlexWrap,
  FormItem,
  RedText,
  SecondaryHeading,
} from 'components/UIComponents/FormStyles'
import PlusIcon from 'components/icons/PlusIcon'
import dayjs from 'dayjs'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import DatePicker from './DatePicker'
import ReactDOMServer from 'react-dom/server'
import { useDispatch, useSelector } from 'react-redux'
import EvaluationProcessScheduleTemplate from 'components/EmailTemplate/EvaluationProcessScheduleTemplate'
import { sendNotificationBulkEmail } from 'modules/Students/actions'

const RadioGroup = styled(AntdRadio.Group)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 36px;
  margin-top: 8px;

  .ant-radio-wrapper {
    white-space: break-spaces;
    overflow: hidden;
    align-items: center;
    text-overflow: ellipsis;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
  .ant-radio-inner {
    margin-top: -5px;
  }
`

const EvaluationForm = ({
  isEditRoleOnView = false,
  singleRoleData = {},
  addNewRound,
  updateRoundData,
  updateNewRound,
  roundData,
  setSortedItems,
  sortedItems,
  save,
  setSave,
  openDrawer,
  setRoundValues,
  roundValues,
  atsParam,
  candidateCall,
  setOpenDrawer,
  scheduleTrue,
  setScheduleTrue,
  isEditingForm,
  setIsEditingForm,
  setSaveEnable,
  rolesMetrics,
  StudentEmailList,
  roleData
}) => {
  const dispatch = useDispatch()
  const institute = useSelector(state => state.auth.instituteDetails)
  const userData = useSelector(state => state.auth.userData)
  const userRoleList = useSelector(state => state.auth.userRoleList)
  const [duplicateRoundName, setDuplicateRoundName] = useState(false)

  const [currentId, setCurrentId] = useState('')
  const datePickerRef = useRef()
  const [disableNameField, setDisableNameField] = useState(false)
  const [editText, setEditText] = useState(false)
  const [key, setKey] = useState(0)
  const [error,setError] = useState(true)
  const [studentEmailListData,setStudentEmailListData] = useState([])
  const handleClear = () => {
    setKey(prevKey => prevKey + 1)
  }
  const handleEditDelete = (current, action, disableName = false) => {
    if (action == 'edit') {
      setDisableNameField(disableName)
      setIsEditingForm(true)
      setCurrentId(current?.name)
      setRoundValues({
        ...roundValues,
        roundNameError: '',
        interviewTypeError: '',
        assessmentTypeError: '',
        roundDescriptionError: '',
        startDateError: '',
        endDateError: '',
        roundName: current?.name,
        interviewType: current?.prePlacement === true ? '' : current?.type,
        assessmentType:
          current?.prePlacement === true
            ? ''
            : current?.assesmentType
            ? current?.assesmentType
            : '',
        faceToFaceType:
          current?.prePlacement === true
            ? ''
            : current?.faceToFaceType
            ? current?.faceToFaceType
            : '',
        roundDescription: current?.description,
        startDate: dayjs(current?.startDate).format('DD/MM/YYYY'),
        endDate: dayjs(current?.endDate).format('DD/MM/YYYY'),
        id: current?.id ?? '',
        prePlacement: current?.prePlacement ?? false,
      })
      setKey(prevKey => prevKey + 1)
      setEditText(true)
    }
    if (action == 'delete') {
      let newData = sortedItems?.filter(item => item?.name != current?.name)
      setSortedItems(newData)
      setSaveCall({ saveDetailSecond: true, saveDetailfirst: true })
    }
    if (action == 'cancel' || action == 'delete') {
      setIsEditingForm(false)
      setEditText(true)
      setKey(prevKey => prevKey + 1)
      setRoundValues({
        ...roundValues,
        roundName: '',
        roundNameError: '',
        interviewType: '',
        interviewTypeError: '',
        assessmentType: '',
        assessmentTypeError: '',
        roundDescription: '',
        faceToFaceType: '',
        roundDescriptionError: '',
        startDateError: '',
        endDateError: '',
        startDate: null,
        endDate: null,
        id: '',
        prePlacement: false,
      })
      handleClear()
      setDisableNameField(false)
    }
  }
  const RadioOptions = [
    {
      id: 4,
      label: 'CV Screening',
      value: 'CV_SCREENING',
      disabled: isEditRoleOnView,
    },
    {
      id: 1,
      label: 'Assessment',
      value: 'ASSESMENT',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Group Discussion',
      value: 'GROUP',
      disabled: isEditRoleOnView,
    },
    {
      id: 3,
      label: 'Interview',
      value: 'FACE_TO_FACE',
      disabled: isEditRoleOnView,
    },
  ]
  const assessmentOptions = [
    {
      id: 1,
      label: 'Cognitive',
      value: 'COGNITIVE',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Technical',
      value: 'TECHNICAL',
      disabled: isEditRoleOnView,
    },
    {
      id: 3,
      label: 'Communication',
      value: 'COMUNICATION',
      disabled: isEditRoleOnView,
    },
  ]

  const faceToFaceOptions = [
    {
      label: 'Domain Experts',
      value: 'DOMAIN_EXPERTS',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'HR Round',
      value: 'HR_ROUND',
      disabled: isEditRoleOnView,
    },
  ]

  const handleOnChange = (value, key) => {
    setSave(false)
    setRoundValues({ ...roundValues, [key]: value, [key + 'Error']: '' })

    if (key === 'startDate') {
      setRoundValues({
        ...roundValues,
        endDate: '',
        [key]: value,
        [key + 'Error']: '',
      })
    }
    if (key === 'endDate') {
      setRoundValues({
        ...roundValues,
        [key]: value,
        [key + 'Error']: '',
      })
    }
    if (key == 'roundName') {
      if (
        sortedItems
          ?.map(item => item?.name?.toLowerCase())
          ?.includes(value?.toLowerCase()?.trim())
      ) {
        setDuplicateRoundName(true)
        setRoundValues({
          ...roundValues,
          [key]: value,
          [key + 'Error']: 'Round name already exist.',
        })
      } else {
        setDuplicateRoundName(false)
        setRoundValues({ ...roundValues, [key]: value, [key + 'Error']: '' })
      }
    }
    if (key == 'interviewType') {
      setRoundValues({
        ...roundValues,
        assessmentType: '',
        [key]: value,
        [key + 'Error']: '',
      })
    }

    if (key === 'prePlacement') {
      setRoundValues({
        ...roundValues,
        ...(value === true && {
          type: '',
          assesmentType: '',
          faceToFaceType: '',
        }),

        [key]: value,
      })
    }
  }

  const [saveCall, setSaveCall] = useState({
    saveDetailfirst: false,
    saveDetailSecond: false,
  })

  useEffect(() => {
    if (!save) {
      if (
        roundValues.roundName !== '' ||
        (roundValues.startDate !== '' && roundValues.startDate !== null) ||
        (roundValues.endDate !== '' && roundValues.endDate !== null) ||
        roundValues.interviewType != '' ||
        roundValues.prePlacement ||
        (roundValues.roundDescription !== '' &&
          roundValues.roundDescription !== '<p><br></p>')
      ) {
        setSaveEnable(false)
        setSaveCall({ ...saveCall, saveDetailfirst: false })
      } else if (saveCall.saveDetailSecond) {
        setSaveCall({ ...saveCall, saveDetailfirst: true })
        setSaveEnable(false)
      } else {
        setSaveEnable(true)
      }
    }
  }, [roundValues, save])

  const handleSubmit = async type => {
    let isValid = true
    let localState = roundValues
    if (!roundValues.roundName) {
      isValid = false
      localState = { ...localState, roundNameError: 'Please Enter round name' }
    }
    if (!roundValues.prePlacement && !roundValues.interviewType) {
      isValid = false
      localState = {
        ...localState,
        interviewTypeError: 'Please Select round type',
      }
    }
    if (!roundValues.startDate) {
      isValid = false
      localState = {
        ...localState,
        startDateError: 'Please enter start date',
      }
    }
    if (!roundValues.endDate) {
      isValid = false
      localState = {
        ...localState,
        endDateError: 'Please enter end date',
      }
    }
    if (!roundValues.prePlacement) {
      if (
        (roundValues.interviewType == 'ASSESMENT' ||
          roundValues.interviewType == 'EXTERNAL_ASSESMENT') &&
        !roundValues.assessmentType
      ) {
        isValid = false
        localState = {
          ...localState,
          assessmentTypeError:
            roundValues.interviewType == 'ASSESMENT'
              ? 'Please Select assessment type'
              : 'Please select external assessment type',
        }
      } else {
        localState = {
          ...localState,
          assessmentTypeError: '',
        }
      }
      if (
        roundValues.interviewType == 'FACE_TO_FACE' &&
        !roundValues.faceToFaceType
      ) {
        isValid = false
        localState = {
          ...localState,
          faceToFaceTypeError: 'Please Select Face To Face Type',
        }
      } else {
        localState = {
          ...localState,
          faceToFaceTypeError: '',
        }
      }
    }
    if (
      !roundValues.roundDescription ||
      roundValues.roundDescription == '<p><br></p>'
    ) {
      isValid = false
      localState = {
        ...localState,
        roundDescriptionError: 'Please enter description',
      }
    }
    if (isValid && !duplicateRoundName) {
      let [startDay, startMonth, startYear] = roundValues.startDate.split('/')
      let startDate = new Date(
        `${startYear}-${startMonth.padStart(2, '0')}-${startDay.padStart(
          2,
          '0'
        )}`
      )
      let now = new Date()
      startDate.setHours(now.getUTCHours() + 5)
      startDate.setMinutes(now.getUTCMinutes() + 30)
      startDate.setSeconds(now.getUTCSeconds())
      startDate.setMilliseconds(now.getUTCMilliseconds())
      let [endDay, endMonth, endYear] = roundValues.endDate.split('/')
      let endDate = new Date(
        `${endYear}-${endMonth.padStart(2, '0')}-${endDay.padStart(2, '0')}`
      )
      endDate.setHours(now.getUTCHours() + 5)
      endDate.setMinutes(now.getUTCMinutes() + 30)
      endDate.setSeconds(now.getUTCSeconds())
      endDate.setMilliseconds(now.getUTCMilliseconds())
      if (isEditingForm) {
        let newData = sortedItems?.map(item =>
          (item?.name === currentId ? true : '')
            ? {
                applied: item.applied,
                name: roundValues.roundName?.trim(),
                type:
                  roundValues.prePlacement === true
                    ? ''
                    : roundValues.interviewType.toUpperCase(),
                assesmentType:
                  roundValues.prePlacement === true
                    ? ''
                    : roundValues.assessmentType.toUpperCase(),
                description: roundValues.roundDescription,
                faceToFaceType:
                  roundValues.prePlacement === true
                    ? ''
                    : roundValues.faceToFaceType.toUpperCase(),
                startDate: startDate,
                endDate: endDate,
                id: roundValues.id ?? '',
                prePlacement: roundValues.prePlacement,
              }
            : item
        )
        setSortedItems(newData)
      } else if (sortedItems?.length) {
        setSortedItems(prevSortedItems => {
          return [
            ...prevSortedItems,
            {
              name: roundValues.roundName?.trim(),
              type:
                roundValues.prePlacement === true
                  ? ''
                  : roundValues.interviewType.toUpperCase(),
              assesmentType:
                roundValues.prePlacement === true
                  ? ''
                  : roundValues.assessmentType.toUpperCase(),
              faceToFaceType:
                roundValues.prePlacement === true
                  ? ''
                  : roundValues.faceToFaceType.toUpperCase(),
              description: roundValues.roundDescription,
              startDate: startDate.toISOString(),
              endDate: endDate.toISOString(),
              prePlacement: roundValues.prePlacement,
            },
          ]
        })
      } else {
        setSortedItems([
          {
            name: roundValues.roundName?.trim(),
            type:
              roundValues.prePlacement === true
                ? ''
                : roundValues.interviewType.toUpperCase(),
            assesmentType:
              roundValues.prePlacement === true
                ? ''
                : roundValues.assessmentType.toUpperCase(),
            faceToFaceType:
              roundValues.prePlacement === true
                ? ''
                : roundValues.faceToFaceType.toUpperCase(),
            description: roundValues.roundDescription,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            prePlacement: roundValues.prePlacement,
          },
        ])
      }

      setError(isValid)
      if (type === 'save') {
        setScheduleTrue(true)
      }

      clearAll()
      if (type === 'update') {
        setSaveEnable(false)
        setSaveCall({ saveDetailSecond: true, saveDetailfirst: true })
      }
    } else {
      setSave(false)
      setRoundValues(localState)
    }
  }

  useEffect(() => {
    if (save) {
      if (saveCall.saveDetailfirst) {
        setScheduleTrue(true)
      } else handleSubmit('save')
    }
  }, [save, saveCall])
  const clearAll = () => {
    setEditText(true)
    setKey(prevKey => prevKey + 1)
    setRoundValues({
      ...roundValues,
      roundName: '',
      roundNameError: '',
      interviewType: '',
      interviewTypeError: '',
      assessmentType: '',
      assessmentTypeError: '',
      roundDescription: '',
      faceToFaceTypeError: '',
      faceToFaceType: '',
      roundDescriptionError: '',
      startDate: null,
      endDateError: '',
      startDateError: '',
      endDate: null,
      id: '',
      prePlacement: false,
    })
    handleClear()
    setIsEditingForm(false)
    setCurrentId('')
    setDisableNameField(false)
  }
  useEffect(() => {
    setEditText(false)
  }, [editText])
  const addRound = async () => {
    const { data } = await addNewRound(atsParam)
    if (candidateCall) {
      candidateCall(atsParam)
    }
    setSortedItems(data?.data)
  }
  useEffect(() => {
    setSaveCall({ saveDetailfirst: false, saveDetailSecond: false })
    if (atsParam && openDrawer) addRound()
  }, [atsParam, openDrawer])

  let roundsCount = sortedItems?.length ?? 0
  useEffect(() => {
    if (scheduleTrue) {
      let payload = {
        rounds: sortedItems.map((item, index) => ({ ...item, order: index })),
        forCorporate: false,
      }
      updateNewRound(payload, atsParam)
     
      // Send email to all students about evaluation process and schedule
      try {
        const orderedRounds = sortedItems.map((item, index) => ({
          ...item,
          order: index,
        }))

        const roleName = roleData?.tittle 
          
        const companyName =
        roleData?.company?.companyName 

        const placementOfficerName = `${userData?.first_name || ''} ${
          userData?.last_name || ''
        }`.trim()
        const placementOfficerContact =
          userData?.phone_number || institute?.contactNumber || ''

        const emailPayloads = []

        const getRoleName = id => {
          let roleName = userRoleList?.filter(data => data?.id === id)?.[0]?.name
          return roleName ?? 'Admin'
        }

        const getUserRoleName = () => {
          return getRoleName(
            userData?.pluginlive_id
              ? userData?.admin?.instRoleId
              : userData?.admin_role_id ?? userData?.role_id
          )
        }

        ;(studentEmailListData || []).forEach(candidate => {
          const student = candidate?.student || {}
          const studentName = `${student?.firstName || ''} ${
            student?.lastName || ''
          }`.trim()
          const to = student?.studentPersonalProfile?.primaryEmail || ''
          if (!to) return

          const templateData = {
            studentName: studentName || 'Student',
            roleName,
            companyName,
            rounds: orderedRounds,
            placementOfficerName,
            placementOfficerContact,
            signatureName: `${userData?.first_name || ''} ${
              userData?.last_name || ''
            }`.trim(),
            signatureRole: getUserRoleName(),
            signatureInstitute: institute?.campusName || 'Institute',
            signatureContact:
              userData?.phone_number || institute?.contactNumber,
          }

          const htmlBody = ReactDOMServer.renderToString(
            <EvaluationProcessScheduleTemplate data={templateData} />
          )

          emailPayloads.push({
            to,
            subject: `Evaluation Process – ${roleName} at ${companyName}`,
            htmlBody,
          })
        })

        if (emailPayloads.length > 0) {
          dispatch(sendNotificationBulkEmail(emailPayloads))
        }
      } catch (err) {
        // silent fail for notification sending
      }
      setScheduleTrue(false)
      setSave(false)
      if(error === true){
        setOpenDrawer(false)
      } 
    }
  }, [sortedItems, scheduleTrue])

  useEffect(() => {
    if (updateRoundData?.message == 'Success') {
      addNewRound(atsParam)
    }
  }, [updateRoundData])

  useEffect(() => {
    fetchStudentEmailList()
  }, [])

  const fetchStudentEmailList = async () => {
    const { data } = await StudentEmailList(atsParam)
    setStudentEmailListData(data?.result)
    console.log(data?.result,'fetchStudentEmailList',atsParam)
  }
  const handleStartDateChange = (date, dateString) => {
    setRoundValues({
      ...roundValues,
      startDate: dateString,
      endDate: null,
      startDateError: '',
    })
  }

  const handleEndDateChange = (date, dateString) => {
    setRoundValues({
      ...roundValues,
      endDate: dateString,
      endDateError: '',
    })
  }

  useEffect(() => {
    setEditText(true)
  }, [openDrawer])

  return (
    <div key={openDrawer}>
      {roundData?.length || sortedItems?.length ? (
        <DragDiv
          availableItem={roundData?.length ? roundData : []}
          sortedItems={sortedItems}
          setSortedItems={setSortedItems}
          onEditClick={handleEditDelete}
          setEditText={setEditText}
          editText={editText}
        />
      ) : null}

      {(isEditingForm ||
        ((rolesMetrics?.rounds?.length !== 0 &&
          rolesMetrics?.rounds?.[rolesMetrics?.rounds?.length - 1]?.count) ||
          0) === 0) && (
        <>
          {(!singleRoleData?.isInterviewScheduled ||
            isEditingForm ||
            (rolesMetrics?.rounds?.length &&
              rolesMetrics?.rounds[rolesMetrics?.rounds?.length - 1]?.count ===
                0)) && (
            <div style={{ scrollPaddingTop: '300px' }} id="editForm">
              {!isEditingForm && (
                <SecondaryHeading>Round {roundsCount + 1}</SecondaryHeading>
              )}

              <div>
                <div style={{ marginTop: '2em', marginBottom: '1.5em' }}>
                  <Label>Round name *</Label>
                </div>
                <Input
                  type="text"
                  width="100%"
                  placeholder="Add Round Name"
                  value={roundValues?.roundName}
                  onChange={({ target }) =>
                    handleOnChange(target.value, 'roundName')
                  }
                  status={roundValues?.roundNameError && 'error'}
                  disabled={disableNameField}
                />
                <RedText>{roundValues?.roundNameError} </RedText>
              </div>
              <FormItem>
                <Checkbox
                  onChange={({ target }) =>
                    handleOnChange(target.checked, 'prePlacement')
                  }
                  checked={roundValues.prePlacement}
                >
                  Pre Placement Talk
                </Checkbox>
              </FormItem>
              {}
              {!roundValues?.prePlacement && (
                <div>
                  <div style={{ marginTop: '2em', marginBottom: '1em' }}>
                    <Label>Evaluation type *</Label>
                  </div>
                  <FormItem>
                    <RadioGroup
                      flexFlow="wrap"
                      onChange={({ target }) =>
                        handleOnChange(target.value, 'interviewType')
                      }
                      value={roundValues?.interviewType}
                    >
                      {RadioOptions?.map((item, index) => (
                        <Radio
                          key={index + item?.value}
                          border={true}
                          label={item?.label}
                          value={item?.value}
                          disabled={singleRoleData?.isInterviewScheduled}
                        />
                      ))}
                    </RadioGroup>
                  </FormItem>
                  <RedText>{roundValues?.interviewTypeError}</RedText>
                </div>
              )}
              {!roundValues?.prePlacement && (
                <>
                  {roundValues?.interviewType == 'ASSESMENT' ? (
                    <div>
                      <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                        <Label>Assessment Type *</Label>
                      </div>
                      <FormItem>
                        <RadioGroup
                          spaceBetween
                          onChange={({ target }) =>
                            handleOnChange(target.value, 'assessmentType')
                          }
                          value={roundValues?.assessmentType}
                        >
                          {assessmentOptions?.map((item, index) => (
                            <Radio
                              width={'30%'}
                              key={index + item?.value}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                              disabled={singleRoleData?.isInterviewScheduled}
                            />
                          ))}
                        </RadioGroup>
                      </FormItem>
                      <RedText>{roundValues?.assessmentTypeError}</RedText>
                    </div>
                  ) : roundValues?.interviewType == 'FACE_TO_FACE' ? (
                    <div>
                      <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                        <Label>Face To Face Type *</Label>
                      </div>
                      <FormItem>
                        <RadioGroup
                          onChange={({ target }) =>
                            handleOnChange(target?.value, 'faceToFaceType')
                          }
                          gap="37px"
                          value={roundValues?.faceToFaceType}
                        >
                          {faceToFaceOptions?.map((item, index) => (
                            <Radio
                              width={'30%'}
                              key={index + item?.value}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                              disabled={singleRoleData?.isInterviewScheduled}
                            />
                          ))}
                        </RadioGroup>
                      </FormItem>
                      <RedText>{roundValues?.faceToFaceTypeError}</RedText>
                    </div>
                  ) : null}
                </>
              )}
              <Row justify="space-between" type="flex">
                <Col span={11}>
                  <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                    <Label>Start Date *</Label>
                  </div>

                  <DatePicker
                    id="startDate"
                    ref={datePickerRef}
                    onChange={handleStartDateChange}
                    value={roundValues.startDate}
                    // isEditable={isEditingForm}
                    disabledDate={d => {
                      const lastItem =
                        sortedItems.length > 0
                          ? sortedItems[sortedItems.length - 1]
                          : null
                      const currentDate = moment().startOf('day')

                      if (lastItem && lastItem.startDate) {
                        const lastStartDate = moment(
                          lastItem.startDate
                        ).startOf('day')

                        // If last startDate is before current date, use current date
                        const effectiveDate = lastStartDate.isBefore(
                          currentDate
                        )
                          ? currentDate
                          : lastStartDate

                        return d.isBefore(effectiveDate)
                      } else {
                        // Disable past dates compared to the current date
                        return !d || d.isBefore(currentDate)
                      }
                    }}
                  />
                  <RedText>{roundValues?.startDateError} </RedText>
                </Col>
                <Col span={11}>
                  <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                    <Label>End Date*</Label>
                  </div>

                  <DatePicker
                    id="endDate"
                    ref={datePickerRef}
                    onChange={handleEndDateChange}
                    value={roundValues.endDate}
                    disabledDate={d =>
                      d.isBefore(moment().add(-1, 'day')) ||
                      d.isBefore(
                        moment(roundValues.startDate, 'DD/MM/YYYY').subtract(
                          0,
                          'day'
                        ),
                        'day'
                      )
                    }
                  />
                  <RedText>{roundValues?.endDateError} </RedText>
                </Col>
              </Row>
              <div>
                <FormItem>
                  <RichEditor
                    key={key + 'roundDescription'}
                    labelName="Round description *"
                    placeholder="E.g.  There is no negative marking."
                    value={roundValues?.roundDescription}
                    onChange={data => handleOnChange(data, 'roundDescription')}
                    editText={editText}
                  />
                </FormItem>
              </div>
              <RedText>{roundValues?.roundDescriptionError}</RedText>
              <div id="section1"></div>
              {isEditingForm ? (
                <FlexWrap gap="20px">
                  <Button.Secondary
                    text={'Cancel'}
                    width="100%"
                    onClick={() => handleEditDelete('', 'cancel')}
                  />
                  <Button.Secondary
                    text={'Update Round'}
                    width="100%"
                    dashed="true"
                    onClick={() => handleSubmit('update')}
                  />
                </FlexWrap>
              ) : (
                <Button.Secondary
                  text={'Add Rounds'}
                  width="100%"
                  icon={<PlusIcon color="#3249D7" />}
                  dashed="true"
                  disable={
                    rolesMetrics?.rounds?.length &&
                    rolesMetrics?.rounds[rolesMetrics?.rounds?.length - 1]
                      ?.count > 0
                  }
                  onClick={() => handleSubmit('update')}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default EvaluationForm
